import React from 'react';
import styled from  'styled-components'

const WelcomeSection = styled.div`
  width: 100%;
  background: #fff;
  position: relative;
  .linkPaper {
    position: absolute;
    top: -16px;
    left: 0;
    width: 100%;
    z-index: 9999999999;
  }
  .linkPaper2 {
    position: absolute;
    bottom: -17px;
    left: 0;
    width: 100%;
    z-index: 9999999999;
  }
  div {
    display: flex;
    img {
      width: 20%;
      animation: moveSlideshow 2s linear infinite;
    }
    @keyframes moveSlideshow {
    100% { 
      transform: translateX(-100%);  
    }
  }
  
}

`;

const Welcome = () => {
  return (
    <WelcomeSection>
      <img className='linkPaper' src="images/link_paper.png" alt='연결'/>
      <div>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
        <img src="images/welcome.png" alt="welcome"/>
      </div>
      <img className='linkPaper2' src="images/link_paper.png" alt='연결'/>
    </WelcomeSection>
  );
};

export default Welcome;